import { Config } from 'common/config'
import { EColors } from 'common/styles'
import { Button } from 'components/buttons'
import { Styled } from 'components/Styled'
import { useTranslation } from 'react-i18next'
import { StyledButtonText } from './styled'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <>
      <Styled.FlexWrapper direction="column" gap={28}>
        {/* Phone */}
        <Styled.FlexWrapper gap={20}>
          <Styled.PBody1>{t('phone')}:</Styled.PBody1>
          <StyledButtonText >
            {Config.General.phone}
          </StyledButtonText>
        </Styled.FlexWrapper>

        {/* Social media */}
        <Styled.FlexWrapper gap={20}>
          <Styled.PBody1>{t('social.media')}:</Styled.PBody1>
          <Button.SocialMedia gap={16} />
        </Styled.FlexWrapper>
      </Styled.FlexWrapper>
    </>
  )
}
